import {
  retrieveReportsMatterDemandReport,
  type RetrieveReportsMatterDemandReportInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsMatterDemandReportQueryOptions = (
  filters: RetrieveReportsMatterDemandReportInput,
) => ({
  queryKey: [queryKeys.reports, "matter-demand-report", filters] as const,
  queryFn: () => retrieveReportsMatterDemandReport(filters),
});
